module.exports = __webpack_public_path__ + "./welfare-movie_1451d20d447f69ce96979708f7e8bbf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/welfare-movie.jpg
// module id = 628
// module chunks = 0